const explicitApiBase = (process.env.REACT_APP_API_BASE_URL || '').trim();

let fallbackApiBase = 'http://localhost:8000';
if (typeof window !== 'undefined') {
	const host = (window.location.hostname || '').toLowerCase();
	const isLocalHost = host === 'localhost' || host === '127.0.0.1';

	// In non-local browser deployments, prefer same-origin API if env var is missing.
	if (!isLocalHost) {
		fallbackApiBase = window.location.origin;
	}
}

const API_BASE_URL = explicitApiBase || fallbackApiBase;

export default API_BASE_URL;
